import { render, staticRenderFns } from "./ContactIconFilledBlack.vue?vue&type=template&id=523580ee"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523580ee')) {
      api.createRecord('523580ee', component.options)
    } else {
      api.reload('523580ee', component.options)
    }
    module.hot.accept("./ContactIconFilledBlack.vue?vue&type=template&id=523580ee", function () {
      api.rerender('523580ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ContactIconFilledBlack.vue"
export default component.exports